import isNil from 'lodash/isNil';
import {ReferenceTypeVo} from '../../common/shared/api/karina/vo/enums/ReferenceTypeVo.enum';
import {ViewTypeVo} from '../../common/shared/api/karina/vo/enums/ViewTypeVo.enum';
import {MoreVo} from '../../common/shared/api/karina/vo/MoreVo.interface';
import {ReferenceVo} from '../../common/shared/api/karina/vo/reference/ReferenceVo.interface';
import {ViewDataVo} from '../../common/shared/api/karina/vo/ViewDataVo.interface';
import {
  Group,
  ItemType,
  Maybe,
  MetaInfoType,
  SectionType,
  User,
} from '../generated/types';
import {createDataKey} from './DataKey';
import {createGroupType} from './GroupType';
import {createItem} from './Item';
import {createMoreItem} from './MoreItem';

const HAS_MORE_VIEW_TYPE_LIST = [
  ViewTypeVo.SeriesCardView,
  ViewTypeVo.SingleCardView,
  ViewTypeVo.SeriesPosterView,
  ViewTypeVo.SinglePosterView,
];

export function createGroupWithViewDataVo(
  userInfo: Maybe<User>,
  {
    metaInfoType,
    sectionType,
    view_data,
    sectionId,
    reference,
    more,
    is_fetch_recommend,
  }: {
    metaInfoType?: MetaInfoType;
    sectionType: SectionType;
    view_data: ViewDataVo;
    reference?: ReferenceVo;
    sectionId: string;
    more?: MoreVo;
    is_fetch_recommend?: boolean;
  }
): Group {
  const {type: referenceType, view_type, reference_key, additional} = view_data;
  const dataTypeKey = createDataKey({
    view_type,
    reference_key,
    additional,
    ...(!isNil(is_fetch_recommend) ? {is_fetch_recommend} : {}),
  });
  const id = `${sectionId}-group-${reference_key}`;

  const group: Group = {
    id,
    type: createGroupType(view_type, sectionType),
    dataKey: dataTypeKey,
  };

  if (
    !reference ||
    referenceType === ReferenceTypeVo.Reference ||
    is_fetch_recommend //  헬릭스 큐레이션의 경우 무조건 lazy 하게 불러옵니다
  ) {
    return group;
  }
  const data = reference[view_type][reference_key];
  /**
   * 쿼드 섹션과 테마 섹션의 경우 여러 개의 배너 아이템이 존재하더라도 한 개의 빅배너 아이템만을 보여줘야 합니다.
   */
  const isUsingStandaloneBanner = sectionType === SectionType.Theme;

  const items = !data
    ? []
    : data
        .map(view =>
          createItem(userInfo, {
            viewItemVo: {
              viewItem: view,
              viewType: view_type,
              sectionType,
              metaInfoType,
            },
          })
        )
        .filter(
          (item, idx) =>
            item.type !== ItemType.Banner ||
            !isUsingStandaloneBanner ||
            (isUsingStandaloneBanner && idx === 0)
        );
  if (more && HAS_MORE_VIEW_TYPE_LIST.includes(view_type)) {
    items.push(createMoreItem(more, view_type));
  }

  group.items = items;
  return group;
}
